import RadioPicker from 'library/components/form/radio';
import { useState } from 'react';
import {
  Content,
  SearchIcon,
  SearchContainer,
  SearchInput,
} from '../styles';
import withFormContainer from '../hocs/with-form-container';

const Index = ({
  required = false,
  options = [],
  placeholder,
  onSearch,
  isAddEnabled = false,
  ...restProps
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [newOptions, setNewOptions] = useState([]);

  const handleSearch = (e) => {
    const newSearchValue = e.target.value;

    setSearchValue(newSearchValue);
    onSearch(newSearchValue);
  };

  const handleAdd = (event) => {
    if(event.key === 'Enter') {
      event.preventDefault();

      setNewOptions([...newOptions, { value: searchValue, text: searchValue }]);
      setSearchValue('');
    }
  };

  return (
    <>
      <SearchContainer>
        <SearchIcon top="33px" className="icon-magnifier" />
        <SearchInput placeholder={placeholder} value={searchValue} onChange={handleSearch} onKeyPress={isAddEnabled ? handleAdd : undefined} />
      </SearchContainer>
      <Content>
        <RadioPicker
          required={required}
          options={[...options, ...newOptions]}
          {...restProps}
        />
      </Content>
    </>
  );
};

export default withFormContainer(Index);
